@if (content) {
  <div class="cx-card" [class.cx-card-border]="border" [class.cx-card-fit-to-container]="fitToContainer">
    <!-- Card Header -->
    <div class="card-header" [ngClass]="{ 'card-header--default': content.header }">
      <mat-chip-list aria-label="header">
        @if (content.header && !editMode) {
          <mat-chip
            class="card-header__tag"
            color="primary"
            class="card-header__tag"
            selected
            >{{ content.header }}</mat-chip
            >
          }
          @if (content.tag && content.tag.length > 0) {
            <mat-chip
              class="card-header__tag"
              color="default"
              class="card-header__tag--info"
              >{{ content.tag }}</mat-chip
              >
            }
          </mat-chip-list>
        </div>
        <!-- Card Body -->
        <div class="card-body cx-card-body" [class.cx-card-delete]="editMode">
          <!-- Edit message -->
          @if (editMode) {
            <div class="cx-card-delete-msg">
              {{ content.deleteMsg }}
            </div>
          }
          <!-- Card title -->
          @if (content.title) {
            <h4 class="cx-card-title">
              {{ content.title }}
            </h4>
          }
          <!-- Card Content -->
          <div class="cx-card-container">
            <!-- Card Label -->
            <div class="cx-card-label-container">
              @if (content.textBold) {
                <div class="cx-card-label-bold">
                  {{ content.textBold }}
                </div>
              }
              @for (line of content.text; track line) {
                <div>
                  <div class="cx-card-label">{{ line }}</div>
                </div>
              }
              @for (item of content.paragraphs; track item) {
                <div class="cx-card-paragraph">
                  <div class="cx-card-paragraph-title">{{ item.title }}</div>
                  @for (text of item.text; track text) {
                    <div>
                      <div class="cx-card-paragraph-text">{{ text }}</div>
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Image -->
            @if (content.img) {
              <div class="cx-card-img-container">
                <cx-icon [type]="content.img"></cx-icon>
              </div>
            }
          </div>
          <!-- Edit Mode Actions -->
          @if (editMode) {
            <div class="row cx-card-body-delete">
              <div class="col-md-6">
                <button class="btn btn-block btn-secondary" (click)="cancelEdit()">
                  {{ 'common.cancel' | cxTranslate }}
                </button>
              </div>
              <div class="col-md-6">
                <button class="btn btn-block btn-primary" (click)="delete()">
                  {{ 'common.delete' | cxTranslate }}
                </button>
              </div>
            </div>
          }
          <!-- Actions -->
          @if (content.actions && !editMode) {
            <div class="cx-card-actions">
              @for (action of content.actions; track action) {
                <div>
                  <div>
                    @switch (action.event) {
                      @case ('delete') {
                        <button
                          class="cx-card-link card-link btn-link cx-action-link"
                          (click)="delete()"
                          (keydown.enter)="delete()"
                          tabindex="0"
                          >
                          {{ action.name }}
                        </button>
                      }
                      @case ('default') {
                        <button
                          class="btn btn-primary btn-block default"
                          (click)="setDefault()"
                          (keydown.enter)="setDefault()"
                          tabindex="0"
                          >
                          {{ action.name }}
                        </button>
                      }
                      @case ('send') {
                        <button
                          class="cx-card-link card-link btn-link cx-action-link"
                          (click)="send()"
                          (keydown.enter)="send()"
                          tabindex="0"
                          >
                          {{ action.name }}
                        </button>
                      }
                      @case ('edit') {
                        <button
                          class="cx-card-link card-link btn-link cx-action-link"
                          (click)="edit()"
                          (keydown.enter)="edit()"
                          tabindex="0"
                          >
                          {{ action.name }}
                        </button>
                      }
                      @default {
                        <button href="{{ action.link }}" class="card-link btn-link cx-action-link" tabindex="0">
                          {{ action.name }}
                        </button>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
